import React, { useState } from "react";
import { createWorker, PSM } from "tesseract.js";
import EXIF from "exif-js";
import html2canvas from "html2canvas";

// 🔹 Enhance image with blur + sharpening (separate function)
export const enhanceImage = (srcMat) => {
  let denoised = new window.cv.Mat();
  window.cv.GaussianBlur(srcMat, denoised, new window.cv.Size(1, 1), 0);

  let sharpened = new window.cv.Mat();
  let kernel = window.cv.matFromArray(
    3,
    3,
    window.cv.CV_32F,
    [0, -0.25, 0, -0.25, 2.0, -0.25, 0, -0.25, 0]
  );
  window.cv.filter2D(denoised, sharpened, window.cv.CV_8U, kernel);

  let final = new window.cv.Mat();
  sharpened.convertTo(final, -1, 1.1, 10);

  denoised.delete();
  sharpened.delete();
  kernel.delete();

  return final;
};

//one working solution
// 🔹 Fix orientation (EXIF first, OCR fallback). No enhancement inside.
// export const fixOrientation = async (imgSrc) => {
//   return new Promise(async (resolve, reject) => {
//     try {
//       let blob = null;

//       // 🧠 If imgSrc is a URL string, fetch it first
//       if (typeof imgSrc === "string") {
//         const response = await fetch(imgSrc, { mode: "cors" });
//         if (!response.ok) throw new Error("Failed to fetch image");
//         blob = await response.blob();
//       } else if (imgSrc instanceof Blob) {
//         blob = imgSrc;
//       } else {
//         return reject(new Error("Invalid imgSrc type"));
//       }

//       const imgElement = document.createElement("img");
//       imgElement.crossOrigin = "Anonymous"; // ⚡ Allow CORS images
//       imgElement.src = URL.createObjectURL(blob);

//       const totalStart = performance.now();

//       imgElement.onload = async () => {
//         try {
//           const loadEnd = performance.now();
//           console.log(
//             `⏱️ Image load time: ${(loadEnd - totalStart).toFixed(2)} ms`
//           );

//           let src = window.cv.imread(imgElement);
//           let rotateCode = null;

//           // 🧭 Step 1: EXIF Orientation
//           try {
//             EXIF.getData(imgElement, function () {
//               const orientation = EXIF.getTag(this, "Orientation");
//               if (orientation === 6) rotateCode = window.cv.ROTATE_90_CLOCKWISE;
//               if (orientation === 8)
//                 rotateCode = window.cv.ROTATE_90_COUNTERCLOCKWISE;
//               if (orientation === 3) rotateCode = window.cv.ROTATE_180;
//             });
//           } catch (exifErr) {
//             console.warn("⚠️ EXIF read failed:", exifErr);
//           }

//           // 🧠 Step 2: OCR fallback if EXIF not found
//           if (rotateCode === null) {
//             const ocrWorker = await createWorker();

//             const getTextScore = async (mat) => {
//               const can = document.createElement("canvas");
//               window.cv.imshow(can, mat);
//               const { data } = await ocrWorker.recognize(can);
//               return (data.text.match(/[A-Za-z0-9]/g) || []).length;
//             };

//             const originalScore = await getTextScore(src);

//             const rotations = [
//               { code: window.cv.ROTATE_90_CLOCKWISE },
//               { code: window.cv.ROTATE_90_COUNTERCLOCKWISE },
//               { code: window.cv.ROTATE_180 },
//             ];

//             const scores = await Promise.all(
//               rotations.map(async (r) => {
//                 const temp = new window.cv.Mat();
//                 window.cv.rotate(src, temp, r.code);
//                 const score = await getTextScore(temp);
//                 temp.delete();
//                 return { ...r, score };
//               })
//             );

//             scores.push({ code: null, score: originalScore });
//             scores.sort((a, b) => b.score - a.score);
//             rotateCode = scores[0].code;

//             await ocrWorker.terminate();
//           }

//           // 🌀 Step 3: Apply rotation
//           let dst = new window.cv.Mat();
//           if (rotateCode !== null) {
//             window.cv.rotate(src, dst, rotateCode);
//           } else {
//             dst = src.clone();
//           }

//           // 🖼️ Step 4: Convert to Blob
//           const canvas = document.createElement("canvas");
//           window.cv.imshow(canvas, dst);
//           canvas.toBlob(
//             (outputBlob) => {
//               if (outputBlob) {
//                 resolve(URL.createObjectURL(outputBlob)); // ✅ Return usable URL
//               } else {
//                 reject(new Error("Canvas toBlob failed"));
//               }
//             },
//             "image/png",
//             1.0
//           );

//           src.delete();
//           dst.delete();
//         } catch (err) {
//           console.error("❌ Error in fixOrientation:", err);
//           reject(err);
//         }
//       };

//       imgElement.onerror = (err) => {
//         console.error("❌ Image failed to load in fixOrientation:", err);
//         reject(err);
//       };
//     } catch (outerErr) {
//       reject(outerErr);
//     }
//   });
// };

// Helper function to convert displayed image to blob via screenshot
export const captureImageAsBlob = async (imageElement) => {
  try {
    // Take screenshot of the image element
    const canvas = await html2canvas(imageElement, {
      useCORS: false, // Don't need CORS for screenshot
      allowTaint: true, // Allow cross-origin images
      backgroundColor: null,
      logging: false,
      scale: 1, // Adjust quality if needed
    });

    // Convert canvas to blob
    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error("Screenshot failed"));
        }
      }, "image/png");
    });
  } catch (error) {
    console.error("Screenshot capture failed:", error);
    throw error;
  }
};
//latest implementation will use it
// export const fixOrientation = async (imgSrc) => {
//   return new Promise((resolve, reject) => {
//     try {
//       const imgElement = document.createElement("img");
//       // Enable CORS for remote images
//       if (typeof imgSrc === "string" && /^https?:\/\//.test(imgSrc)) {
//         imgElement.crossOrigin = "anonymous";
//       }

//       // Set image source
//       if (imgSrc instanceof Blob) {
//         imgElement.src = URL.createObjectURL(imgSrc);
//       } else {
//         imgElement.src = imgSrc;
//       }

//       const totalStart = performance.now();

//       imgElement.onload = async () => {
//         try {
//           const loadEnd = performance.now();
//           console.log(
//             `⏱️ Image load time: ${(loadEnd - totalStart).toFixed(2)} ms`
//           );

//           // Read image into OpenCV
//           const startCvRead = performance.now();
//           let src = window.cv.imread(imgElement);
//           const endCvRead = performance.now();
//           console.log(
//             `⏱️ OpenCV read time: ${(endCvRead - startCvRead).toFixed(2)} ms`
//           );

//           let rotateCode = null;

//           // Attempt EXIF orientation correction
//           const exifStart = performance.now();
//           try {
//             await new Promise((res) =>
//               EXIF.getData(imgElement, function () {
//                 const orientation = EXIF.getTag(this, "Orientation");
//                 if (orientation === 6)
//                   rotateCode = window.cv.ROTATE_90_CLOCKWISE;
//                 if (orientation === 8)
//                   rotateCode = window.cv.ROTATE_90_COUNTERCLOCKWISE;
//                 if (orientation === 3) rotateCode = window.cv.ROTATE_180;
//                 res();
//               })
//             );
//           } catch (exifErr) {
//             console.warn("⚠️ EXIF read failed:", exifErr);
//           }
//           const exifEnd = performance.now();
//           console.log(
//             `⏱️ EXIF check time: ${(exifEnd - exifStart).toFixed(2)} ms`
//           );

//           // Fallback to OCR-based rotation if needed
//           if (rotateCode === null) {
//             const ocrStart = performance.now();
//             const ocrWorker = await createWorker();
//             const getTextScore = async (mat) => {
//               const can = document.createElement("canvas");
//               window.cv.imshow(can, mat);
//               const { data } = await ocrWorker.recognize(can);
//               return (data.text.match(/[A-Za-z0-9]/g) || []).length;
//             };

//             const originalScore = await getTextScore(src);

//             let dst90cw = new window.cv.Mat();
//             window.cv.rotate(src, dst90cw, window.cv.ROTATE_90_CLOCKWISE);
//             const score90cw = await getTextScore(dst90cw);

//             let dst90ccw = new window.cv.Mat();
//             window.cv.rotate(
//               src,
//               dst90ccw,
//               window.cv.ROTATE_90_COUNTERCLOCKWISE
//             );
//             const score90ccw = await getTextScore(dst90ccw);

//             let dst180 = new window.cv.Mat();
//             window.cv.rotate(src, dst180, window.cv.ROTATE_180);
//             const score180 = await getTextScore(dst180);

//             console.log("OCR Scores →", {
//               original: originalScore,
//               "90cw": score90cw,
//               "90ccw": score90ccw,
//               180: score180,
//             });

//             const scores = [
//               { code: null, score: originalScore },
//               { code: window.cv.ROTATE_90_CLOCKWISE, score: score90cw },
//               { code: window.cv.ROTATE_90_COUNTERCLOCKWISE, score: score90ccw },
//               { code: window.cv.ROTATE_180, score: score180 },
//             ];
//             scores.sort((a, b) => b.score - a.score);
//             rotateCode = scores[0].code;

//             dst90cw.delete();
//             dst90ccw.delete();
//             dst180.delete();
//             await ocrWorker.terminate();

//             const ocrEnd = performance.now();
//             console.log(
//               `⏱️ OCR scoring time: ${(ocrEnd - ocrStart).toFixed(2)} ms`
//             );
//           }

//           // Apply rotation
//           const rotateStart = performance.now();
//           let dst = new window.cv.Mat();
//           if (rotateCode !== null) {
//             window.cv.rotate(src, dst, rotateCode);
//           } else {
//             dst = src.clone();
//           }
//           const rotateEnd = performance.now();
//           console.log(
//             `⏱️ Rotation time: ${(rotateEnd - rotateStart).toFixed(2)} ms`
//           );

//           // Convert to blob for output
//           const blobStart = performance.now();
//           const canvas = document.createElement("canvas");
//           window.cv.imshow(canvas, dst);

//           canvas.toBlob(
//             (blob) => {
//               const blobEnd = performance.now();
//               console.log(
//                 `⏱️ Blob conversion time: ${(blobEnd - blobStart).toFixed(
//                   2
//                 )} ms`
//               );
//               console.log(
//                 `⏱️ Total fixOrientation time: ${(blobEnd - totalStart).toFixed(
//                   2
//                 )} ms`
//               );

//               if (blob) {
//                 resolve(blob);
//               } else {
//                 reject(new Error("Canvas toBlob failed"));
//               }
//               src.delete();
//               dst.delete();
//             },
//             "image/png",
//             1.0
//           );
//         } catch (err) {
//           console.error("❌ Error in fixOrientation:", err);
//           reject(err);
//         }
//       };

//       imgElement.onerror = (err) => {
//         console.error("❌ Image failed to load in fixOrientation:", err);
//         reject(err);
//       };
//     } catch (outerErr) {
//       reject(outerErr);
//     }
//   });
// };

//new fix orientation code

export const fixOrientation = async (imgSrc) => {
  return new Promise((resolve, reject) => {
    try {
      const imgElement = document.createElement("img");

      // Enable CORS for remote images
      if (typeof imgSrc === "string" && /^https?:\/\//.test(imgSrc)) {
        imgElement.crossOrigin = "anonymous";
      }

      // Set image source
      if (imgSrc instanceof Blob) {
        imgElement.src = URL.createObjectURL(imgSrc);
      } else {
        imgElement.src = imgSrc;
      }

      const totalStart = performance.now();

      imgElement.onload = async () => {
        try {
          const loadEnd = performance.now();
          console.log(
            `⏱️ Image load time: ${(loadEnd - totalStart).toFixed(2)} ms`
          );

          // Read image into OpenCV
          const startCvRead = performance.now();
          let src = window.cv.imread(imgElement);
          const endCvRead = performance.now();
          console.log(
            `⏱️ OpenCV read time: ${(endCvRead - startCvRead).toFixed(2)} ms`
          );

          let rotateCode = null;

          // Attempt EXIF orientation correction
          const exifStart = performance.now();
          try {
            await new Promise((res) =>
              EXIF.getData(imgElement, function () {
                const orientation = EXIF.getTag(this, "Orientation");
                if (orientation === 6)
                  rotateCode = window.cv.ROTATE_90_CLOCKWISE;
                if (orientation === 8)
                  rotateCode = window.cv.ROTATE_90_COUNTERCLOCKWISE;
                if (orientation === 3) rotateCode = window.cv.ROTATE_180;
                res();
              })
            );
          } catch (exifErr) {
            console.warn("⚠️ EXIF read failed:", exifErr);
          }
          const exifEnd = performance.now();
          console.log(
            `⏱️ EXIF check time: ${(exifEnd - exifStart).toFixed(2)} ms`
          );

          // Fallback to OCR-based rotation if needed
          if (rotateCode === null) {
            const ocrStart = performance.now();

            // Create Tesseract worker
            const ocrWorker = await createWorker("eng");

            // Multi-factor scoring function
            const getTextScore = async (mat) => {
              const can = document.createElement("canvas");
              window.cv.imshow(can, mat);
              const { data } = await ocrWorker.recognize(can);

              const text = data.text || "";
              const confidence = data.confidence || 0;

              // Factor 1: Character count
              const charCount = (text.match(/[A-Za-z0-9]/g) || []).length;

              // Factor 2: Word count (3+ letter words)
              const wordCount = (text.match(/[A-Za-z]{3,}/g) || []).length;

              // Factor 3: Properly capitalized words
              const capitalizedCount = (text.match(/[A-Z][a-z]{2,}/g) || [])
                .length;

              // Factor 4: Common English words
              const lowerText = text.toLowerCase();
              const commonWords = [
                "the",
                "and",
                "is",
                "of",
                "to",
                "in",
                "for",
                "a",
                "an",
              ];
              const commonWordCount = commonWords.filter((word) =>
                lowerText.includes(word)
              ).length;

              // Weighted score formula
              const score =
                charCount * 1 + // Base character count
                wordCount * 5 + // Readable words
                capitalizedCount * 8 + // Proper capitalization
                commonWordCount * 10 + // Common words
                confidence * 0.3; // OCR confidence

              console.log(
                `  Sample: "${text.substring(0, 40).replace(/\n/g, " ")}..."`,
                {
                  chars: charCount,
                  words: wordCount,
                  caps: capitalizedCount,
                  common: commonWordCount,
                  conf: confidence.toFixed(1),
                  score: score.toFixed(1),
                }
              );

              return score;
            };

            // Test all 4 orientations
            console.log("🔍 Testing original orientation:");
            const originalScore = await getTextScore(src);

            console.log("🔍 Testing 90° clockwise:");
            let dst90cw = new window.cv.Mat();
            window.cv.rotate(src, dst90cw, window.cv.ROTATE_90_CLOCKWISE);
            const score90cw = await getTextScore(dst90cw);

            console.log("🔍 Testing 90° counter-clockwise:");
            let dst90ccw = new window.cv.Mat();
            window.cv.rotate(
              src,
              dst90ccw,
              window.cv.ROTATE_90_COUNTERCLOCKWISE
            );
            const score90ccw = await getTextScore(dst90ccw);

            console.log("🔍 Testing 180° (upside-down):");
            let dst180 = new window.cv.Mat();
            window.cv.rotate(src, dst180, window.cv.ROTATE_180);
            const score180 = await getTextScore(dst180);

            console.log("📊 Final OCR Scores →", {
              original: originalScore.toFixed(1),
              "90cw": score90cw.toFixed(1),
              "90ccw": score90ccw.toFixed(1),
              "180°": score180.toFixed(1),
            });

            // Compare scores and choose winner
            const scores = [
              { code: null, score: originalScore, name: "Original" },
              {
                code: window.cv.ROTATE_90_CLOCKWISE,
                score: score90cw,
                name: "90° CW",
              },
              {
                code: window.cv.ROTATE_90_COUNTERCLOCKWISE,
                score: score90ccw,
                name: "90° CCW",
              },
              { code: window.cv.ROTATE_180, score: score180, name: "180°" },
            ];

            scores.sort((a, b) => b.score - a.score);

            const winner = scores[0];
            const runnerUp = scores[1];
            const confidenceThreshold = 1.25; // Winner must be 25% better

            // Choose rotation based on confidence
            if (winner.score > runnerUp.score * confidenceThreshold) {
              rotateCode = winner.code;
              console.log(
                `✅ Clear winner: ${winner.name} ` +
                  `(score: ${winner.score.toFixed(
                    1
                  )} vs ${runnerUp.score.toFixed(1)})`
              );
            } else if (winner.score > runnerUp.score * 1.1) {
              rotateCode = winner.code;
              console.log(
                `⚠️ Marginal winner: ${winner.name} ` +
                  `(score: ${winner.score.toFixed(
                    1
                  )} vs ${runnerUp.score.toFixed(1)})`
              );
            } else {
              rotateCode = null;
              console.log(
                `⚠️ No clear winner, keeping original. ` +
                  `Best: ${winner.score.toFixed(
                    1
                  )}, Second: ${runnerUp.score.toFixed(1)}`
              );
            }

            // Clean up OpenCV matrices
            dst90cw.delete();
            dst90ccw.delete();
            dst180.delete();

            // Terminate Tesseract worker
            await ocrWorker.terminate();

            const ocrEnd = performance.now();
            console.log(
              `⏱️ OCR scoring time: ${(ocrEnd - ocrStart).toFixed(2)} ms`
            );
          }

          // Apply rotation
          const rotateStart = performance.now();
          let dst = new window.cv.Mat();
          if (rotateCode !== null) {
            window.cv.rotate(src, dst, rotateCode);
            console.log("🔄 Applied rotation");
          } else {
            dst = src.clone();
            console.log("✓ No rotation needed");
          }
          const rotateEnd = performance.now();
          console.log(
            `⏱️ Rotation time: ${(rotateEnd - rotateStart).toFixed(2)} ms`
          );

          // Convert to blob for output
          const blobStart = performance.now();
          const canvas = document.createElement("canvas");
          window.cv.imshow(canvas, dst);

          canvas.toBlob(
            (blob) => {
              const blobEnd = performance.now();
              console.log(
                `⏱️ Blob conversion time: ${(blobEnd - blobStart).toFixed(
                  2
                )} ms`
              );
              console.log(
                `⏱️ Total fixOrientation time: ${(blobEnd - totalStart).toFixed(
                  2
                )} ms`
              );

              if (blob) {
                resolve(blob);
              } else {
                reject(new Error("Canvas toBlob failed"));
              }

              // Clean up OpenCV matrices
              src.delete();
              dst.delete();
            },
            "image/png",
            1.0
          );
        } catch (err) {
          console.error("❌ Error in fixOrientation:", err);
          reject(err);
        }
      };

      imgElement.onerror = (err) => {
        console.error("❌ Image failed to load in fixOrientation:", err);
        reject(err);
      };
    } catch (outerErr) {
      reject(outerErr);
    }
  });
};

//Testing purpose only
// export const fixOrientation = async (imgSrc) => {
//   return new Promise(async (resolve, reject) => {
//     try {
//       const imgElement = document.createElement("img");

//       // ✅ Step 1: Handle URL decoding (fixes double-encoded S3 URLs)
//       let finalUrl = imgSrc;
//       if (typeof imgSrc === "string") {
//         try {
//           finalUrl = decodeURIComponent(imgSrc);
//         } catch (e) {
//           console.warn("⚠️ URL decode failed, using original URL:", imgSrc);
//         }
//       }

//       // ✅ Step 2: Enable CORS for remote URLs
//       if (typeof finalUrl === "string" && /^https?:\/\//.test(finalUrl)) {
//         imgElement.crossOrigin = "anonymous";
//       }

//       // ✅ Step 3: Attempt to fetch as blob (CORS-safe)
//       // If it fails (blocked by CORS), fallback to direct src
//       if (typeof finalUrl === "string" && /^https?:\/\//.test(finalUrl)) {
//         try {
//           const response = await fetch(finalUrl, { mode: "cors" });
//           if (!response.ok) throw new Error("Fetch failed: " + response.status);
//           const blob = await response.blob();
//           imgElement.src = URL.createObjectURL(blob);
//         } catch (fetchErr) {
//           console.warn(
//             "⚠️ Direct fetch failed (CORS or access issue). Fallback to direct src:",
//             fetchErr
//           );
//           imgElement.src = finalUrl;
//         }
//       } else if (imgSrc instanceof Blob) {
//         imgElement.src = URL.createObjectURL(imgSrc);
//       } else {
//         imgElement.src = finalUrl;
//       }

//       const totalStart = performance.now();

//       imgElement.onload = async () => {
//         try {
//           const loadEnd = performance.now();
//           console.log(
//             `⏱️ Image load time: ${(loadEnd - totalStart).toFixed(2)} ms`
//           );

//           // ✅ Read image with OpenCV
//           const startCvRead = performance.now();
//           let src = window.cv.imread(imgElement);
//           const endCvRead = performance.now();
//           console.log(
//             `⏱️ OpenCV read time: ${(endCvRead - startCvRead).toFixed(2)} ms`
//           );

//           let rotateCode = null;

//           // ✅ Step 4: Try EXIF orientation correction
//           const exifStart = performance.now();
//           try {
//             await new Promise((res) =>
//               EXIF.getData(imgElement, function () {
//                 const orientation = EXIF.getTag(this, "Orientation");
//                 if (orientation === 6)
//                   rotateCode = window.cv.ROTATE_90_CLOCKWISE;
//                 if (orientation === 8)
//                   rotateCode = window.cv.ROTATE_90_COUNTERCLOCKWISE;
//                 if (orientation === 3) rotateCode = window.cv.ROTATE_180;
//                 res();
//               })
//             );
//           } catch (exifErr) {
//             console.warn("⚠️ EXIF read failed:", exifErr);
//           }
//           const exifEnd = performance.now();
//           console.log(
//             `⏱️ EXIF check time: ${(exifEnd - exifStart).toFixed(2)} ms`
//           );

//           // ✅ Step 5: Apply rotation if needed
//           const rotateStart = performance.now();
//           let dst = new window.cv.Mat();
//           if (rotateCode !== null) {
//             window.cv.rotate(src, dst, rotateCode);
//             console.log("🔄 Applied rotation");
//           } else {
//             dst = src.clone();
//             console.log("✓ No rotation needed");
//           }
//           const rotateEnd = performance.now();
//           console.log(
//             `⏱️ Rotation time: ${(rotateEnd - rotateStart).toFixed(2)} ms`
//           );

//           // ✅ Step 6: Convert to Blob and resolve
//           const blobStart = performance.now();
//           const canvas = document.createElement("canvas");
//           window.cv.imshow(canvas, dst);
//           canvas.toBlob(
//             (blob) => {
//               const blobEnd = performance.now();
//               console.log(
//                 `⏱️ Total fixOrientation time: ${(blobEnd - totalStart).toFixed(
//                   2
//                 )} ms`
//               );
//               if (blob) {
//                 resolve(blob);
//               } else {
//                 reject(new Error("Canvas toBlob failed"));
//               }
//               src.delete();
//               dst.delete();
//             },
//             "image/png",
//             1.0
//           );
//         } catch (err) {
//           console.error("❌ Error in fixOrientation inner block:", err);
//           reject(err);
//         }
//       };

//       imgElement.onerror = (err) => {
//         console.error("❌ Image failed to load in fixOrientation:", err);
//         reject(err);
//       };
//     } catch (outerErr) {
//       console.error("❌ fixOrientation outer error:", outerErr);
//       reject(outerErr);
//     }
//   });
// };

// export const fixOrientation = async (imgSrc) => {
//   return new Promise((resolve, reject) => {
//     try {
//       const imgElement = document.createElement("img");

//       if (typeof imgSrc === "string" && /^https?:\/\//.test(imgSrc)) {
//         imgElement.crossOrigin = "anonymous";
//       }

//       if (imgSrc instanceof Blob) {
//         imgElement.src = URL.createObjectURL(imgSrc);
//       } else {
//         imgElement.src = imgSrc;
//       }

//       const totalStart = performance.now();

//       imgElement.onload = async () => {
//         let src = null;
//         let dst = null;
//         let dst90cw = null;
//         let dst90ccw = null;
//         let dst180 = null;
//         let ocrWorker = null;

//         try {
//           const loadEnd = performance.now();
//           console.log(
//             `⏱️ Image load time: ${(loadEnd - totalStart).toFixed(2)} ms`
//           );

//           // ✅ Wrap OpenCV operations in try-catch
//           try {
//             src = window.cv.imread(imgElement);

//             if (!src || src.empty()) {
//               throw new Error("OpenCV matrix is empty");
//             }
//           } catch (cvError) {
//             console.error("❌ OpenCV imread failed:", cvError);
//             // Return original image blob
//             const response = await fetch(imgElement.src);
//             const blob = await response.blob();
//             resolve(blob);
//             return;
//           }

//           let rotateCode = null;

//           // Try EXIF
//           try {
//             await new Promise((res) =>
//               EXIF.getData(imgElement, function () {
//                 const orientation = EXIF.getTag(this, "Orientation");
//                 if (orientation === 6)
//                   rotateCode = window.cv.ROTATE_90_CLOCKWISE;
//                 if (orientation === 8)
//                   rotateCode = window.cv.ROTATE_90_COUNTERCLOCKWISE;
//                 if (orientation === 3) rotateCode = window.cv.ROTATE_180;
//                 res();
//               })
//             );
//           } catch (exifErr) {
//             console.warn("⚠️ EXIF failed:", exifErr);
//           }

//           // ✅ Skip OCR for now (enable later after CORS is fixed)
//           // This prevents the memory errors

//           // Apply rotation
//           try {
//             dst = new window.cv.Mat();

//             if (rotateCode !== null) {
//               window.cv.rotate(src, dst, rotateCode);
//               console.log("✅ Rotation applied");
//             } else {
//               dst = src.clone();
//               console.log("✅ No rotation needed");
//             }
//           } catch (rotateError) {
//             console.error("❌ OpenCV rotate failed:", rotateError);
//             // Use original
//             dst = src.clone();
//           }

//           // Convert to blob
//           const canvas = document.createElement("canvas");

//           try {
//             window.cv.imshow(canvas, dst);
//           } catch (imshowError) {
//             console.error("❌ OpenCV imshow failed:", imshowError);
//             // Manual canvas drawing fallback
//             canvas.width = imgElement.width;
//             canvas.height = imgElement.height;
//             const ctx = canvas.getContext("2d");
//             ctx.drawImage(imgElement, 0, 0);
//           }

//           canvas.toBlob(
//             (blob) => {
//               // Cleanup
//               try {
//                 if (src && !src.isDeleted()) src.delete();
//                 if (dst && !dst.isDeleted()) dst.delete();
//               } catch (cleanupErr) {
//                 console.warn("⚠️ Cleanup warning:", cleanupErr);
//               }

//               if (blob) {
//                 console.log(`✅ Blob created`);
//                 resolve(blob);
//               } else {
//                 reject(new Error("Blob creation failed"));
//               }
//             },
//             "image/jpeg",
//             0.95
//           );
//         } catch (err) {
//           console.error("❌ Error in fixOrientation:", err);

//           // Cleanup on error
//           try {
//             if (src && !src.isDeleted()) src.delete();
//             if (dst && !dst.isDeleted()) dst.delete();
//           } catch (cleanupErr) {
//             console.warn("⚠️ Error cleanup warning:", cleanupErr);
//           }

//           // Fallback to original
//           try {
//             const response = await fetch(imgElement.src);
//             const blob = await response.blob();
//             console.log("✅ Fallback successful");
//             resolve(blob);
//           } catch (fallbackErr) {
//             console.error("❌ Fallback failed:", fallbackErr);
//             reject(err);
//           }
//         }
//       };

//       imgElement.onerror = (err) => {
//         console.error("❌ Image failed to load:", err);
//         reject(new Error(`Image load failed`));
//       };
//     } catch (outerErr) {
//       console.error("❌ Outer error:", outerErr);
//       reject(outerErr);
//     }
//   });
// };

let sharedWorker = null;

async function getOCRWorker() {
  if (!sharedWorker) {
    sharedWorker = await createWorker();
    await sharedWorker.loadLanguage("eng");
    await sharedWorker.initialize("eng", 1); // 1 = OEM.LSTM_ONLY
  }
  return sharedWorker;
}

// 🔹 Optional: downscale images for faster OCR
const scaleDown = (mat, maxSize = 1200) => {
  let h = mat.rows,
    w = mat.cols;
  if (h > maxSize || w > maxSize) {
    const scale = Math.min(maxSize / w, maxSize / h);
    let resized = new window.cv.Mat();
    window.cv.resize(mat, resized, new window.cv.Size(0, 0), scale, scale);
    return resized;
  }
  return mat.clone();
};

// 🔹 Main orientation fixer
//second working solution
// export const fixOrientation = async (imgSrc) => {
//   return new Promise((resolve, reject) => {
//     try {
//       const imgElement = document.createElement("img");

//       if (imgSrc instanceof Blob) {
//         imgElement.src = URL.createObjectURL(imgSrc);
//       } else {
//         imgElement.src = imgSrc;
//       }

//       imgElement.onload = async () => {
//         const timings = {};
//         const startTotal = performance.now();

//         try {
//           // OpenCV image read timing
//           const t0 = performance.now();
//           let src = window.cv.imread(imgElement);
//           timings.openCVRead = performance.now() - t0;
//           console.log(
//             `⏱️ OpenCV read time: ${timings.openCVRead.toFixed(2)} ms`
//           );

//           let rotateCode = null;

//           // EXIF processing timing
//           const exifStart = performance.now();
//           try {
//             EXIF.getData(imgElement, function () {
//               const orientation = EXIF.getTag(this, "Orientation");
//               if (orientation === 6) rotateCode = window.cv.ROTATE_90_CLOCKWISE;
//               if (orientation === 8)
//                 rotateCode = window.cv.ROTATE_90_COUNTERCLOCKWISE;
//               if (orientation === 3) rotateCode = window.cv.ROTATE_180;
//             });
//           } catch (exifErr) {
//             console.warn("⚠️ EXIF read failed:", exifErr);
//           }
//           timings.exifCheck = performance.now() - exifStart;
//           console.log(
//             `⏱️ EXIF processing time: ${timings.exifCheck.toFixed(2)} ms`
//           );

//           // If EXIF doesn't decide rotation
//           if (rotateCode === null) {
//             if (src.cols > src.rows) {
//               // Horizontal detection timing start
//               const cvHorizontalStart = performance.now();

//               let gray = new window.cv.Mat();
//               window.cv.cvtColor(src, gray, window.cv.COLOR_RGBA2GRAY);
//               let thresh = new window.cv.Mat();
//               window.cv.threshold(
//                 thresh,
//                 thresh,
//                 128,
//                 255,
//                 window.cv.THRESH_BINARY
//               );
//               let moments = window.cv.moments(thresh, true);
//               let cx = moments.m10 / moments.m00;

//               if (cx < src.cols / 2) {
//                 rotateCode = window.cv.ROTATE_90_COUNTERCLOCKWISE;
//                 console.log("⏪ Horizontal-left detected: rotate 90° CCW");
//               } else {
//                 rotateCode = window.cv.ROTATE_90_CLOCKWISE;
//                 console.log("⏩ Horizontal-right detected: rotate 90° CW");
//               }

//               gray.delete();
//               thresh.delete();

//               timings.ocrCheck = 0;
//               console.log(
//                 `⏱️ OpenCV horizontal orientation detection time: ${(
//                   performance.now() - cvHorizontalStart
//                 ).toFixed(2)} ms`
//               );
//             } else {
//               // Vertical - OCR timing start
//               const ocrStart = performance.now();

//               const worker = await createWorker();
//               await worker.setParameters({ tessedit_pageseg_mode: PSM.AUTO });

//               const getTextScore = async (mat) => {
//                 const can = document.createElement("canvas");
//                 window.cv.imshow(can, mat);
//                 const { data } = await worker.recognize(can);
//                 return (data.text.match(/[A-Za-z0-9]/g) || []).length;
//               };

//               const originalScore = await getTextScore(src);

//               let dst180 = new window.cv.Mat();
//               window.cv.rotate(src, dst180, window.cv.ROTATE_180);
//               const upsideScore = await getTextScore(dst180);

//               console.log("🔎 OCR Scores →", {
//                 original: originalScore,
//                 upsideDown: upsideScore,
//               });

//               if (upsideScore > originalScore) {
//                 rotateCode = window.cv.ROTATE_180;
//                 console.log("🔄 Upside-down detected → rotate 180°");
//               }

//               dst180.delete();
//               await worker.terminate();

//               timings.ocrCheck = performance.now() - ocrStart;
//               console.log(
//                 `⏱️ OCR processing time: ${timings.ocrCheck.toFixed(2)} ms`
//               );
//             }
//           }

//           // Apply rotation timing
//           const rotStart = performance.now();
//           let dst = new window.cv.Mat();
//           if (rotateCode !== null) {
//             window.cv.rotate(src, dst, rotateCode);
//           } else {
//             dst = src.clone();
//           }
//           timings.rotation = performance.now() - rotStart;
//           console.log(`⏱️ Rotation time: ${timings.rotation.toFixed(2)} ms`);

//           // Convert to Blob timing
//           const blobStart = performance.now();
//           const canvas = document.createElement("canvas");
//           window.cv.imshow(canvas, dst);
//           canvas.toBlob(
//             (blob) => {
//               timings.blobConversion = performance.now() - blobStart;
//               timings.total = performance.now() - startTotal;

//               console.log(
//                 `⏱️ Blob conversion time: ${timings.blobConversion.toFixed(
//                   2
//                 )} ms`
//               );
//               console.log(
//                 `⏱️ Total processing time: ${timings.total.toFixed(2)} ms`
//               );

//               if (blob) resolve(blob);
//               else reject(new Error("Canvas toBlob failed"));
//             },
//             "image/png",
//             1.0
//           );

//           src.delete();
//           dst.delete();
//         } catch (err) {
//           console.error("❌ Error in fixOrientation:", err);
//           reject(err);
//         }
//       };

//       imgElement.onerror = (err) => {
//         console.error("❌ Image failed to load in fixOrientation:", err);
//         reject(err);
//       };
//     } catch (outerErr) {
//       reject(outerErr);
//     }
//   });
// };

//third working solution
// export const fixOrientation = async (imgSrc) => {
//   return new Promise((resolve, reject) => {
//     try {
//       const imgElement = document.createElement("img");

//       if (imgSrc instanceof Blob) {
//         imgElement.src = URL.createObjectURL(imgSrc);
//       } else {
//         imgElement.src = imgSrc;
//       }

//       imgElement.onload = async () => {
//         const timings = {};
//         const startTotal = performance.now();

//         try {
//           // OpenCV read
//           const t0 = performance.now();
//           let src = window.cv.imread(imgElement);
//           timings.openCVRead = performance.now() - t0;
//           console.log(
//             `⏱️ OpenCV read time: ${timings.openCVRead.toFixed(2)} ms`
//           );

//           let rotateCode = null;

//           // EXIF check
//           const exifStart = performance.now();
//           try {
//             EXIF.getData(imgElement, function () {
//               const orientation = EXIF.getTag(this, "Orientation");
//               if (orientation === 6) rotateCode = window.cv.ROTATE_90_CLOCKWISE;
//               if (orientation === 8)
//                 rotateCode = window.cv.ROTATE_90_COUNTERCLOCKWISE;
//               if (orientation === 3) rotateCode = window.cv.ROTATE_180;
//             });
//           } catch (exifErr) {
//             console.warn("⚠️ EXIF read failed:", exifErr);
//           }
//           timings.exifCheck = performance.now() - exifStart;
//           console.log(
//             `⏱️ EXIF processing time: ${timings.exifCheck.toFixed(2)} ms`
//           );

//           if (rotateCode === null) {
//             if (src.cols > src.rows) {
//               // Horizontal detection using center of mass
//               const cvHorizontalStart = performance.now();

//               let gray = new window.cv.Mat();
//               window.cv.cvtColor(src, gray, window.cv.COLOR_RGBA2GRAY);
//               let thresh = new window.cv.Mat();
//               window.cv.threshold(
//                 gray,
//                 thresh,
//                 128,
//                 255,
//                 window.cv.THRESH_BINARY
//               );

//               let moments = window.cv.moments(thresh, true);
//               let cx = moments.m10 / moments.m00;

//               if (cx < src.cols / 2) {
//                 rotateCode = window.cv.ROTATE_90_COUNTERCLOCKWISE;
//                 console.log("⏪ Horizontal-left detected: rotate 90° CCW");
//               } else {
//                 rotateCode = window.cv.ROTATE_90_CLOCKWISE;
//                 console.log("⏩ Horizontal-right detected: rotate 90° CW");
//               }

//               gray.delete();
//               thresh.delete();

//               timings.ocrCheck = 0; // skipped for horizontal
//               console.log(
//                 `⏱️ OpenCV horizontal orientation detection time: ${(
//                   performance.now() - cvHorizontalStart
//                 ).toFixed(2)} ms`
//               );
//             } else {
//               // Vertical detection: OCR with downscaling and shared worker
//               const ocrStart = performance.now();

//               const worker = await getOCRWorker();

//               const scaledSrc = scaleDown(src);

//               const getTextScore = async (mat) => {
//                 const can = document.createElement("canvas");
//                 window.cv.imshow(can, mat);
//                 const { data } = await worker.recognize(can);
//                 return (data.text.match(/[A-Za-z0-9]/g) || []).length;
//               };

//               const originalScore = await getTextScore(scaledSrc);

//               let dst180 = new window.cv.Mat();
//               window.cv.rotate(scaledSrc, dst180, window.cv.ROTATE_180);
//               const upsideScore = await getTextScore(dst180);

//               console.log("🔎 OCR Scores →", {
//                 original: originalScore,
//                 upsideDown: upsideScore,
//               });

//               scaledSrc.delete();
//               dst180.delete();

//               if (upsideScore > originalScore) {
//                 rotateCode = window.cv.ROTATE_180;
//                 console.log("🔄 Upside-down detected → rotate 180°");
//               }

//               timings.ocrCheck = performance.now() - ocrStart;
//               console.log(
//                 `⏱️ OCR processing time: ${timings.ocrCheck.toFixed(2)} ms`
//               );
//             }
//           }

//           // Apply rotation
//           const rotStart = performance.now();
//           let dst = new window.cv.Mat();
//           if (rotateCode !== null) {
//             window.cv.rotate(src, dst, rotateCode);
//           } else {
//             dst = src.clone();
//           }
//           timings.rotation = performance.now() - rotStart;
//           console.log(`⏱️ Rotation time: ${timings.rotation.toFixed(2)} ms`);

//           // Convert to Blob
//           const blobStart = performance.now();
//           const canvas = document.createElement("canvas");
//           window.cv.imshow(canvas, dst);
//           canvas.toBlob(
//             (blob) => {
//               timings.blobConversion = performance.now() - blobStart;
//               timings.total = performance.now() - startTotal;

//               console.log(
//                 `⏱️ Blob conversion time: ${timings.blobConversion.toFixed(
//                   2
//                 )} ms`
//               );
//               console.log(
//                 `⏱️ Total processing time: ${timings.total.toFixed(2)} ms`
//               );

//               if (blob) resolve(blob);
//               else reject(new Error("Canvas toBlob failed"));
//             },
//             "image/png",
//             1.0
//           );

//           src.delete();
//           dst.delete();
//         } catch (err) {
//           console.error("❌ Error in fixOrientation:", err);
//           reject(err);
//         }
//       };

//       imgElement.onerror = (err) => {
//         console.error("❌ Image failed to load in fixOrientation:", err);
//         reject(err);
//       };
//     } catch (outerErr) {
//       reject(outerErr);
//     }
//   });
// };

const ImageUploadAndFix = () => {
  const [processed, setProcessed] = useState(null);

  // Handle file upload → only fix orientation
  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async function (ev) {
      const imgSrc = ev.target.result;
      const orientedBlob = await fixOrientation(imgSrc);
      const url = URL.createObjectURL(orientedBlob);
      setProcessed(url);
    };
    reader.readAsDataURL(file);
  };

  // Apply enhancement later (on button click)
  const handleEnhance = () => {
    if (!processed) return;

    const imgElement = document.createElement("img");
    imgElement.src = processed;

    imgElement.onload = () => {
      let src = window.cv.imread(imgElement);
      let enhanced = enhanceImage(src);

      const canvas = document.createElement("canvas");
      window.cv.imshow(canvas, enhanced);

      canvas.toBlob(
        (blob) => {
          if (blob) {
            const url = URL.createObjectURL(blob);
            setProcessed(url);
          }
        },
        "image/png",
        1.0
      );

      src.delete();
      enhanced.delete();
    };
  };

  return (
    <div>
      <h3>Upload, Auto-Rotate & Enhance Later</h3>
      <input type="file" accept="image/*" onChange={handleUpload} />

      {processed && (
        <div style={{ marginTop: "10px" }}>
          <p>Processed (Rotated):</p>
          <img src={processed} alt="processed" width="300" />

          <div style={{ marginTop: "10px" }}>
            <button onClick={handleEnhance}>Enhance Image</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageUploadAndFix;
